export const VERSION_OLD = 'OLD'
export const VERSION_NEW = 'NEW'
